<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.webpage_heading" [ttModel]="setting.webpage_heading"></tt-page-heading>

    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-select ttRememberId="w_labourpositions.factory_id" ttLabel="factory" [(ttModel)]="setting.factory_id" (ttModelChange)="onChanged($event, 'factory_id')" [ttData]="selectListFactories" ttDataId="factory_id" ttDataName="factory_name"></tt-select>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-select ttRememberId="w_labourpositions.workgrp_keyno" ttLabel="workgrp" [(ttModel)]="setting.workgrp_keyno" (ttModelChange)="onChanged($event, 'workgrp_keyno')" [ttData]="selectListWorkGroups" ttDataId="workgrp_keyno" ttDataName="workgrp_name" ttShowClearButton></tt-select>
        </tt-card>
    </div>

    <tt-card class="col-xs-12 col-md-6 p-5">
        <tt-tabs [(ttSelectedId)]="selectedBgLabourPositionsMain" (ttSelectedIdChange)="onTabChange()">
            <tt-tab ttId="LABOURS" ttLabel="gb_labourpositions_main_labours"></tt-tab>
            <tt-tab ttId="POS" ttLabel="gb_labourpositions_main_pos"></tt-tab>
        </tt-tabs>
    </tt-card>

    <tt-grid *ngIf="selectedBgLabourPositionsMain === 'LABOURS' && !!gridLabourPositions" class="flex-1 p-5" [(ttOptions)]="gridLabourPositions"></tt-grid>
    <tt-grid *ngIf="selectedBgLabourPositionsMain === 'POS' && !!gridProductionOrders" class="flex-1 p-5" [(ttOptions)]="gridProductionOrders"></tt-grid>

    <tt-card class="col-xs-12 col-md-12 p-5" *ngIf="setting.show_setting === '1'">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>
